import { Component, Input, OnInit } from '@angular/core';
import { Account, Issue, IssueType, Project } from 'src/app/shared/models';
import { ProjectService } from 'src/app/shared/services';
import { isIssueStageStatus } from 'src/app/shared/helpers/issue-workflow';

@Component({
    selector: 'app-issue-card',
    templateUrl: './issue-card.component.html',
    styleUrls: ['./issue-card.component.scss'],
    standalone: false
})
export class IssueCardComponent implements OnInit {

  public initialized = false;
  @Input() public issue: Issue;
  @Input() public project: Project;
  @Input() public type = true;
  @Input() public status = true;
  @Input() public internal = true;

  public account: Account;
  public issueTypes: IssueType[] = [];

  constructor(
    private projectSrv: ProjectService
  ) { }

  ngOnInit(): void {
    if (this.issue.createdBy) {
      this.account = this.issue.createdBy;
    }
    this.fetchIssueTypes(this.project);
    this.initialized = true;
  }

  /**
   * Fetches IssueType[]
   * @param project Project
   */
  fetchIssueTypes(project: Project): void {
    this.projectSrv.getIssueTypes(project)
      .then((issueTypes: IssueType[]) => {
        this.issueTypes = issueTypes;
      });
  }

  issueTypeLabel(type) {
    return (this.issueTypes || []).find(o => o?.type === type)?.label || type;
  }

  /**
   * The plain open / closed pill stands unless the status is a
   * contractor-workflow stage, which app-issue-stage-chip shows instead: one
   * status pill either way.
   */
  get isStageStatus(): boolean {
    return isIssueStageStatus(this.issue?.status);
  }
}
